import React, { useContext, useState } from 'react';
import { ThemeContext } from './ThemeProvider';
import Icon from '@mdi/react';
import { mdiWhiteBalanceSunny, mdiMoonWaningCrescent } from '@mdi/js';

<Icon path={mdiWhiteBalanceSunny} size={1} />;

export default function ThemeToggle({ className, text, width }) {
  const { theme, toggle } = useContext(ThemeContext);
  const [isHovered, setIsHovered] = useState(false);
  return (
    <button
      className={`theme-toggle ${className || ''}`}
      onClick={toggle}
      aria-pressed={theme === 'dark'}
      title='Toggle theme'
      style={{
        border: `1px solid ${theme === 'dark' ? '#333335' : '#5c5c5f'}`,
        width: isHovered ? `${width}px` : '25px',
        borderRadius: 50,
        whiteSpace: 'nowrap',
        transition: 'all 0.1s ease',
        overflow: 'hidden',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span
        className='flex align-center justify-center'
        style={theme === 'dark' ? { color: '#ffffffff' } : { color: '#dbdbdb' }}
      >
        {isHovered && (
          <span style={{ marginRight: 7 }}>
            {theme === 'dark' ? text.light : text.dark}
          </span>
        )}
        <span className='icon is-small'>
          <Icon
            path={
              theme === 'dark' ? mdiWhiteBalanceSunny : mdiMoonWaningCrescent
            }
            size={1}
            rotate={theme === 'dark' ? 0 : 335}
          />
        </span>
      </span>
    </button>
  );
}
